module.exports = __webpack_public_path__ + "static/media/margate-11.68d9ccf5.jpg";